import React from 'react'

export default class IconsDnDGatedContent extends React.Component {
    render() {
        let color = '#C8C5FE'
        if (this.props.color) color = this.props.color
        let className = 'icons-icon'
        return (
            <svg
                className={className}
                style={this.props.style}
                xmlns='http://www.w3.org/2000/svg'
                width='16'
                height='16'
                viewBox='0 0 16 16'
                fill='none'
            >
                <path
                    d='M3.99999 14.6666C3.64637 14.6666 3.30723 14.5261 3.05718 14.2761C2.80713 14.026 2.66666 13.6869 2.66666 13.3333V2.66659C2.66666 2.31297 2.80713 1.97383 3.05718 1.72378C3.30723 1.47373 3.64637 1.33325 3.99999 1.33325H9.33332C9.54436 1.33291 9.75338 1.37432 9.94834 1.4551C10.1433 1.53588 10.3204 1.65443 10.4693 1.80392L12.8613 4.19592C13.0112 4.34493 13.1301 4.52215 13.2111 4.71736C13.2921 4.91257 13.3337 5.1219 13.3333 5.33325V13.3333C13.3333 13.6869 13.1928 14.026 12.9428 14.2761C12.6927 14.5261 12.3536 14.6666 12 14.6666H3.99999Z'
                    stroke='black'
                    strokeWidth='1.25'
                    strokeLinecap='round'
                    strokeLinejoin='round'
                />
                <path
                    d='M9.33334 1.33325V4.66659C9.33334 4.8434 9.40358 5.01297 9.52861 5.13799C9.65363 5.26301 9.8232 5.33325 10 5.33325H13.3333'
                    stroke='black'
                    strokeWidth='1.25'
                    strokeLinecap='round'
                    strokeLinejoin='round'
                />
                <path d='M8 12V8' stroke='black' strokeLinecap='round' strokeLinejoin='round' />
                <path d='M6 10L8 12L10 10' stroke='black' strokeLinecap='round' strokeLinejoin='round' />
            </svg>
        )
    }
}
